import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '@env/environment';
import { lastValueFrom } from 'rxjs';
import { IConfig } from './config.interface';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private _config: IConfig = {};

  constructor(private _httpClient: HttpClient) {
    lastValueFrom(this._httpClient.get<IConfig>(this.configUrl))
      .then(configRes => {
        this.config = {
          ...this.config,
          ...configRes,
        };
        console.log(
          '🚀 ~ ConfigService ~ constructor ~ this.config',
          this.config
        );
      })
      .catch(err => {
        console.error(err);
        return err;
      });
  }

  get configUrl(): string {
    return `./assets/configuration/${
      environment.production ? 'config.json' : 'config.local.json'
    }`;
  }

  public get config(): IConfig {
    return this._config;
  }

  public set config(value: IConfig) {
    this._config = value;
  }

  getApiBaseUrl(url: string): string {
    return !url.includes('assets') ? this.config.apiBaseUrl : '';
  }
}
